import { SectionOrSubSectionOverview } from 'approot/activity-builder/activity-builder.constants';
import { ActivityBuilderEventType } from 'approot/activity-builder/present/activity-builder-present-data-tracking.utils';
import { StudentSectionOrSubSectionOverview } from '../student/student.constants';

export const PRESENT_ZOOM_STORAGE = 'inq-lb-present-zoom';
export const PRESENT_SLIDE_ID = 'lb-present-slide';
export const PRESENT_MENU_CONTAINER_ID = 'lb-present-menu-container';
export const PRESENT_PRINT_CONTAINER = 'lb-present-print-container';
export const PRESENT_CONTEXT_MENU_CONTAINER =
  'lb-present-context-menu-container';

export type UpdateActiveSectionProps = {
  sectionId: string;
  newSectionOverview?:
    | SectionOrSubSectionOverview
    | StudentSectionOrSubSectionOverview
    | null;
  index?: number;
  eventType: ActivityBuilderEventType;
};

export const PRESENT_PROGRESS_BAR_Z_INDEX = 19;
export const PRESENT_STUDENT_BAR_Z_INDEX = 20;
export const PRESENT_MENU_BUTTON_Z_INDEX = 20;
export const PRESENT_DRAWER_Z_INDEX = 20;
export const PRESENT_DRAWER_DETAILS_Z_INDEX = 21;
export const PRESENT_COMPONENT_RESPONSE_Z_INDEX = 5;
export const PRESENT_RESET_ANSWER_Z_INDEX = 6;
export const PRESENT_PLAYABLE_COMPONENT_INFO_BUTTON_Z_INDEX =
  PRESENT_COMPONENT_RESPONSE_Z_INDEX + 1;

export const PRESENT_DRAWER_WIDTH = 340;

export enum PresentDrawerItem {
  None,
  Activities,
  TeachingNotes,
  Settings,
  Students,
  Translate,
}

export type PresentDrawer = {
  isActive: boolean;
  isDetailActive: boolean;
};
